module.exports = __webpack_public_path__ + "static/assets/d5f67ae3bf2225695aa7ed656082a31f.png";